<template>
  <div class="projectDetail-page">
    <my-brand :routerlist="routerlist" />
    <template v-if="projectData && projectData.length > 0">
      <div v-for="item in projectData" :key="item.project_id" class="projectDetail-container">
        <div class="introduce-content">
          <h2 class="project-title">
            {{ item.project_name }} By
            {{ item.project_artist }}
          </h2>
          <div class="about">
            {{ item.project_description }}
          </div>
          <div class="con-item">
            <p class="single-item">
              Price
              <span class="value">{{ getTokenPrice(item.token_info && item.token_info.PricePerTokenInWei) }}</span>
            </p>
            <p class="single-item">
              License
              <span class="value">{{ item.project_license }}</span>
            </p>
            <p class="single-item">
              Is VIP
              <span class="value">{{ item.is_vip }}</span>
            </p>
            <p class="single-item">
              Total Minted
              <span class="value">
                {{ item.all_tokens && item.all_tokens.length }} /
                {{ item.token_info && item.token_info.MaxInvocations }} MAX
              </span>
            </p>
          </div>
          <div class="btn-wrap">
            <button class="hvr-shutter-out-vertical" @click="toProjectDetail(item.project_id)">
              Visit Project
            </button>
          </div>
        </div>
        <div class="pictureDisplay">
          <div
            v-for="itemChild in item.TokenInfos"
            :key="itemChild.token_id"
            class="img-wrap"
            @click="toTokenDetail(itemChild.token_id)"
          >
            <img
              v-if="itemChild.processed_img"
              v-lazy="`${$config.normalRequestBaseUrl}/art/${itemChild.token_id}/png`"
              alt="img"
            >
            <img
              v-else
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNuvafpok1f34VfmtLMX_0RYNYnJ-aSpv0qQ&usqp=CAU"
              alt="img"
            >
            <h2 class="text-center mt-0 opacity-80 text-sm">
              #{{ itemChild.token_id }}
            </h2>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="noData-wrapper">
      No Data
    </div>
  </div>
</template>

<script>
// import mockData from "@/config/mock.js";
import * as http from '@/common/utils/request.js';
import Web3 from 'web3';
export default {
  data() {
    return {
      projectData: [],
    };
  },
  methods: {
    toTokenDetail(id) {
      this.$router.push(`/token/${id}`);
    },
    toProjectDetail(id) {
      this.$router.push(`/projectDetail/${id}`);
    },
    getTokenPrice(price) {
      if (!price) {
        return false;
      }
      const res = Web3.utils.fromWei(price);
      return `${res} ETH`;
    },
    // 获取项目信息
    async getPurchasedList() {
      const params = {
        pageNum: 1,
        showNum: 100,
      };
      try {
        const res = await http.fetchGet(`/api/tokens/${this.$route.params.address}`, params);
        console.log(res);
        this.projectData = res.data?.data?.OwnerProjectTokens;
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getPurchasedList();
  },
  computed: {
    routerlist(){
      return [{to:'/',name:'Home'},{name:'User'}];
    }
  },
};
</script>

<style lang="less" scoped>
.con-item {
  .single-item {
    display: flex;
    padding: 16px 0 8px 0px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    .value {
      flex: 1;
      text-align: right;
      color: rgba(255, 255, 255, 0.6);
    }
    .site {
      color: rgb(134, 181, 219);
    }
  }
}
.about {
  margin: 16px 0;
  color: rgba(255, 255, 255, 0.4);
}
.btn-wrap {
  width: 100%;
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  button {
    width: 100%;
    padding: 12px 0px;
    color: #fff;
    background-color: #3b4d55;
    font-weight: 600;
    font-size: 18px;
    border-radius: 2px;
    outline: none;
    &:hover {
      border: none;
    }
  }
}

.projectDetail-container {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  padding: 40px 0;
}

@media (max-width: 1025px) {
  .projectDetail-container {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    flex-wrap: wrap;
    .introduce-content {
      width: 100%;
      .project-title {
        font-size: 16px;
      }
    }
    .pictureDisplay {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .img-wrap {
        cursor: pointer;
        width: 28%;
        margin: 10px 10px 10px 0px;
      }
      img {
        border-radius: 8px;
      }
    }
  }
}

@media (min-width: 1026px) {
  .projectDetail-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .introduce-content {
      width: 45%;
      padding: 0px 20px;
      .project-title {
        font-size: 20px;
      }
    }
    .pictureDisplay {
      width: 45%;
      display: flex;
      flex-wrap: wrap;
      .img-wrap {
        cursor: pointer;
        width: 20%;
        margin: 10px;
      }
      img {
        border-radius: 8px;
      }
    }
  }
}
</style>